export default __webpack_public_path__ + "static/media/header-visu3.986ded67.jpg";